import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import {
  BlogCategoryResponse,
  BlogContentListLPayLoad,
  BlogContentListTypeResponse,
  ContentBlogDetailPayload,
  ContentBlogDetailsResponse,
} from "./type";

export const BlogApi = {
  async getListCategoryBlog() {
    const response = await axiosRequest.post<BlogCategoryResponse>(
      "",
      payloadHelper("BlogCategory", null, null)
    );
    return response.data;
  },
  async getListContentBlog(payload: BlogContentListLPayLoad) {
    const response = await axiosRequest.post<BlogContentListTypeResponse>(
      "",
      payloadHelper("BlogList", null, payload)
    );
    return response.data;
  },
  async getContentBlogDetail(payload: ContentBlogDetailPayload) {
    const response = await axiosRequest.post<ContentBlogDetailsResponse>(
      "",
      payloadHelper("Blog", null, payload)
    );
    return response.data;
  },
};
